import { createFileRoute } from "@tanstack/react-router"
import { parseEiResultSection } from "@/entities/emotional-intelligence"
import { ProfileEiResultPage } from "@/pages/profile/ei-result"

export const Route = createFileRoute("/_authenticated/profile/ei-result")({
	component: ProfileEiResultPageWrapper,
	validateSearch: (search) => ({
		section: parseEiResultSection(search.section),
	}),
})

function ProfileEiResultPageWrapper() {
	const { section } = Route.useSearch()
	return <ProfileEiResultPage section={section} />
}
